import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();

export const conversationRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/conversation/:conversationId',
});

export const assistantsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/assistants',
});

export const favoritesRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/favorites',
});

export const settingsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/settings',
});
